"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Randomize array element order in-place
 * using Durstenfeld shuffle algorithm.
 *
 * @param array The array to shuffle.
 *
 * @returns The shuffled array.
 */
function shuffle(array) {
    var shuffled = array.slice(0);
    for (var i = shuffled.length - 1; i > 0; i -= 1) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = shuffled[i];
        shuffled[i] = shuffled[j];
        shuffled[j] = temp;
    }
    return shuffled;
}
exports.default = shuffle;
//# sourceMappingURL=shuffleArray.js.map